@import (reference) '../../../constants/spacing.module.less';

.order-number {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: @space-8;
}

.single-order-number {
  padding-top: @space-8;
}
